import React from 'react';

type OrgUnit = {
  orgUnit: string;
  dfn: string;
};

export function OrgUnit({ dfn, orgUnit }: OrgUnit) {
  return (
    <p>
      <dfn className="invisible">{dfn}</dfn>
      {orgUnit}
    </p>
  );
}
